export const getSidebarDepth = state => state.sidebar.depth;
export const getSelectedFolder = state => state.sidebar.selectedFolder;
export const getSidebarState = state => state.sidebar;
export const getOpenedFolder = state => state.sidebar.openedFolder;
export const isAppUpdateModalOpen = state =>
  state.sidebar.displayAppUpdateModal;
